export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGOUT_USER        = 'LOGOUT_USER';

export const VALIDATE_USER_REQUEST = 'VALIDATE_USER_REQUEST';
export const VALIDATE_USER_SUCCESS = 'VALIDATE_USER_SUCCESS';
export const VALIDATE_USER_FAILURE = 'VALIDATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE';
export const SET_CURRENT_PAGE    = 'SET_CURRENT_PAGE';
export const ON_SEARCH_CHANGE    = 'ON_SEARCH_CHANGE';
export const SET_FILE_VIEW       = 'SET_FILE_VIEW';
export const SET_FILE_SORT_ORDER = 'SET_FILE_SORT_ORDER';
export const SET_FILTERED_IDS    = 'SET_FILTERED_IDS';

export const VIEWED_NOTIFICATION = 'VIEWED_NOTIFICATION';
export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';

export const TOGGLE_CIRCLES = 'TOGGLE_CIRCLES';
export const TOGGLE_CIRCLE  = 'TOGGLE_CIRCLE';

export const TOGGLE_TYPES = 'TOGGLE_TYPES';
export const TOGGLE_TYPE  = 'TOGGLE_TYPE';

export const TOGGLE_FUNDS = 'TOGGLE_FUNDS';
export const TOGGLE_FUND  = 'TOGGLE_FUND';

export const TOGGLE_YEARS = 'TOGGLE_YEARS';
export const TOGGLE_YEAR  = 'TOGGLE_YEAR' ;

export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export const SET_FILTERED_CIRCLES = 'SET_FILTERED_CIRCLES';
export const SET_FILTERED_TYPES   = 'SET_FILTERED_TYPES  ';
export const SET_FILTERED_FUNDS   = 'SET_FILTERED_FUNDS';
export const SET_FILTERED_YEARS   = 'SET_FILTERED_YEARS';

export const CLOSE_DROPDOWNS = 'CLOSE_DROPDOWNS';


// WEBPACK FOOTER //
// ./src/store/types.js